import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import noData from 'highcharts/modules/no-data-to-display';
import Boost from 'highcharts/modules/boost';
import SolidGauge from 'highcharts/modules/solid-gauge';
import more from 'highcharts/highcharts-more';
import HC_stock from 'highcharts/modules/stock';
import IndicatorsCore from 'highcharts/indicators/indicators';
import IndicatorRegressions from 'highcharts/indicators/regressions';
import { Options } from 'highcharts/highstock';
import Timeline from 'highcharts/modules/timeline';
import Theme from 'highcharts/themes/dark-unica';
import Theme2 from 'highcharts/themes/brand-light';
import { NavigationService } from 'src/app/modulos/navigation/service';
import { Subscription } from 'rxjs';
import { HelperService } from '../../helper.service';
require('../pictorial.js')(Highcharts);

HC_stock(Highcharts);
noData(Highcharts);
more(Highcharts);
Boost(Highcharts);
SolidGauge(Highcharts);
IndicatorsCore(Highcharts);
IndicatorRegressions(Highcharts);
// Exporting(Highcharts);
// ExportData(Highcharts);
Theme(Highcharts);
Timeline(Highcharts);

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements OnInit, OnChanges, OnDestroy {
  public Highcharts: typeof Highcharts = Highcharts;

  @Input() options!: Options;
  @Input() style?: string;
  @Input() constructorType: string = 'chart';
  public update: boolean = false;
  chart?: Highcharts.Chart;

  public oscuro$?: Subscription;

  @Output() optionsChange = new EventEmitter<Options>();
  @Output() chartPrint = new EventEmitter<void>();

  constructor(private navigationService: NavigationService) {
    this.chartCallback.bind(this);
  }

  public chartInstance(chart: Highcharts.Chart) {
    this.chart = chart;
  }

  public chartCallback: Highcharts.ChartCallbackFunction = (chart) => {
    setTimeout(() => {
      this.chartPrint.emit();
    }, 100);
  };

  private cambioTema() {
    this.oscuro$?.unsubscribe();
    this.oscuro$ = this.navigationService.modoOscuro$.subscribe((oscuro) => {
      if (oscuro) {
        Theme(Highcharts);
        this.options!.chart!.style = {
          fontFamily: 'monserrat-regular, sans-serif',
          color: 'white',
        };
      } else {
        Theme2(Highcharts);
        this.options!.chart!.style = {
          fontFamily: 'monserrat-regular, sans-serif',
          color: 'black',
        };
      }
      if (this.chart) {
        this.chart?.update(this.options, true, true);
      }
    });
  }

  ngOnChanges() {
    this.update = true;
    this.cambioTema();
    if (this.chart) {
      this.options.accessibility = {
        enabled: false,
      };
      if (this.options?.chart && !this.options?.chart?.style) {
        this.options.chart.style = {
          fontFamily: 'monserrat-regular, sans-serif',
        };
      }
      this.chart?.update(this.options, true, true);
    }
  }

  async ngOnInit(): Promise<void> {
    this.cambioTema();
    if (HelperService.esModoOscuro()) {
      Theme(Highcharts);
      if (this.options.chart) {
        this.options.chart.style = {
          fontFamily: 'monserrat-regular, sans-serif',
          color: 'white',
        };
      }
    } else {
      Theme2(Highcharts);
      if (this.options.chart) {
        this.options.chart.style = {
          fontFamily: 'monserrat-regular, sans-serif',
          color: 'black',
        };
      }
    }
    this.options.accessibility = {
      enabled: false,
    };
    if (this.options?.chart && !this.options?.chart?.style) {
      this.options!.chart!.style = {
        fontFamily: 'monserrat-regular, sans-serif',
      };
    }
  }

  ngOnDestroy() {
    this.oscuro$?.unsubscribe();
  }
}
